import React from 'react';

import { ApButtonIcon } from '@alixpartners/ui-components';
import { withRouter } from 'react-router-dom';
import { IconWrapper, StyledReactTooltip } from './styles';
import ClickOutside from 'react-click-outside';
import { UploadStateContext } from 'contexts/UploadStateContext';
import { TooltipContent } from './TooltipContent';

class UnpublishedControl extends React.Component {
	state = {
		forceClose: false,
	};

	navigateToUnpublishedData = () => {
		const { history } = this.props;

		history.push('/unpublished');
	};

	forceTooltipClose = () => {
		// Force tooltip close while mouse hover on itself
		this.setState({ forceClose: true }, () => {
			this.setState({ forceClose: false });
		});
	};

	hideActiveTooltip = () => {
		StyledReactTooltip.hide();
	};

	getTooltipContent = () => {
		const { isActive, status } = this.props;

		if (isActive) {
			return null;
		}

		const title = status.isUnpublishedDataExists
			? 'Unpublished data for review'
			: 'No new data available';

		const text = status.isUnpublishedDataExists
			? 'There is a new data set available for you to review and publish to the client.'
			: 'The latest data has been published to the client.';
		const buttonText = status.isUnpublishedDataExists ? 'Review' : 'Ok';
		const handleClick = status.isUnpublishedDataExists
			? this.navigateToUnpublishedData
			: this.forceTooltipClose;

		return (
			<TooltipContent
				title={title}
				text={text}
				buttonText={buttonText}
				handleClick={handleClick}
			/>
		);
	};

	render() {
		const { isActive, status } = this.props;
		const { forceClose } = this.state;

		return (
			<React.Fragment>
				<IconWrapper
					hasData={status.isUnpublishedDataExists}
					active={isActive}
					data-for="unpublished"
					date-event="click"
					data-tip={!isActive ? 'tooltip' : undefined}
				>
					<ApButtonIcon theme="dark" iconName="dynamic_feed" />
				</IconWrapper>
				{!forceClose &&
					!isActive && (
						<ClickOutside onClickOutside={this.hideActiveTooltip}>
							<StyledReactTooltip
								id="unpublished"
								isCapture
								event="click"
								place="bottom"
								clickable
								type="light"
								scrollHide
								effect="solid"
								offset={{ left: 65, bottom: 12 }}
								overridePosition={(
									{ left, top },
									currentEvent,
									currentTarget,
									node,
									_1,
									_2,
									_3,
									offset = {}
								) => {
									const {
										right: offsetRight = 0,
										left: offsetLeft = 0,
										top: offsetTop = 0,
										bottom: offSetBottom = 0,
									} = offset;
									const d = document.documentElement;
									left = Math.min(
										d.clientWidth -
											(node.clientWidth + offsetLeft + offsetRight),
										left
									);
									top = Math.min(
										d.clientHeight -
											(node.clientHeight + offSetBottom + offsetTop),
										top
									);

									left = Math.max(0, left);
									top = Math.max(0, top);
									return { top, left };
								}}
								getContent={this.getTooltipContent}
							/>
						</ClickOutside>
					)}
			</React.Fragment>
		);
	}
}

export default withRouter(props => (
	<UploadStateContext.Consumer>
		{({ status }) => <UnpublishedControl {...props} status={status} />}
	</UploadStateContext.Consumer>
));
